import { type UseQueryResult } from '@tanstack/react-query'
import { useApiQuery } from 'hooks/useApiQuery'
import type { Organization } from 'src/types/api'

export const useGetOrganizationsByCorporateAccountId = ({
  corporateAccountId,
}: {
  corporateAccountId: number
}): UseQueryResult<Organization[]> => {
  return useApiQuery({
    path: '/le-connect/organizations/corporate-accounts/{corporateAccountId}',
    method: 'get',
    queryKey: ['/organizations/corporate-accounts/', corporateAccountId],
    queryArgs: { corporateAccountId },
  })
}
